var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[(_vm.mockup !== null)?_c('v-stage',{staticClass:"omcustom-product-image",style:(_vm.style),attrs:{"config":_vm.stageConfig}},[_c('v-layer',[_c('v-rect',{attrs:{"config":{
          width: _vm.stageConfig.width / _vm.stageConfig.scale.x,
          height: _vm.stageConfig.height / _vm.stageConfig.scale.x,
          fill: '#ffffff'
        }}}),_vm._v(" "),_vm._l((_vm.mockup.layers),function(l){return [(l.type === 'Group')?_c('group',{key:l.id,attrs:{"layer":l,"mockupID":_vm.mockup.id,"ratio":_vm.ratio}}):_vm._e(),_vm._v(" "),(l.type === 'Image')?_c('m-image',{key:l.id,attrs:{"layer":l,"mockupID":_vm.mockup.id}}):_vm._e(),_vm._v(" "),(l.type === 'Printarea')?_c('print-area',{key:l.id,attrs:{"layer":l,"ratio":_vm.ratio},on:{"loading":function (loading) {
              var _obj;

              _vm.loadings = Object.assign({}, _vm.loadings, ( _obj = {}, _obj[l.id] = loading, _obj ))
            }}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.isMockupLoading))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1195994e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mockup/Mockup.vue
// module id = 344
// module chunks = 0